import { render, staticRenderFns } from "./ExchangeInfo.vue?vue&type=template&id=2c7a8d2d&scoped=true"
import script from "./ExchangeInfo.vue?vue&type=script&lang=js"
export * from "./ExchangeInfo.vue?vue&type=script&lang=js"
import style0 from "./ExchangeInfo.vue?vue&type=style&index=0&id=2c7a8d2d&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7a8d2d",
  null
  
)

export default component.exports